import type { RouteLocationNormalizedLoaded, Router } from 'vue-router'

/**
 * Навигация к паспорту дочернего объекта в том же семействе маршрутов, что и текущая страница.
 */
export function resolveLinkedChildPassportLocation(
  route: RouteLocationNormalizedLoaded,
  router: Router,
  childListItemId: number,
) {
  const idStr = String(childListItemId)
  if (route.name != null) {
    return router.resolve({
      name: route.name,
      params: { ...route.params, invent_object_id: idStr },
      query: route.query,
    })
  }
  return router.resolve({
    name: 'object.inventory.elements.edit',
    params: { ...route.params, invent_object_id: idStr },
    query: route.query,
  })
}
